import useLanguage from "../../i18n/useLanguage";
import { AI_ORDER_URL } from "../../data/products";

export default function AiOrderSteps() {
  const { t } = useLanguage();
  const steps = [
    ["Siapkan produk", "Unggah foto produk, isi nama dan keunggulannya, lalu cantumkan kontak kamu."],
    ["Tentukan konsep", "Pilih jenis pesanan, jumlah foto atau scene, rasio visual, dan referensi kreatif."],
    ["Periksa & pesan", "Periksa ringkasan harga di form, kirim pesanan, lalu lanjutkan pembayaran."],
  ];
  return (
    <section aria-labelledby="ai-order-steps" className="py-14 border-y border-white/10">
      <h2 id="ai-order-steps" className="text-3xl sm:text-4xl font-bold mb-8">{t("Dari foto produk ke konsep konten")}</h2>
      <ol className="grid md:grid-cols-3 gap-8 mb-10">{steps.map(([title, text], index) => <li key={title}><span className="text-amber-300 text-sm font-bold">0{index + 1}</span><h3 className="text-xl font-bold mt-3 mb-2">{t(title)}</h3><p className="text-gray-400 leading-relaxed">{t(text)}</p></li>)}</ol>
      <a href={AI_ORDER_URL} className="inline-block bg-amber-300 text-black font-bold rounded-xl px-6 py-4 hover:bg-amber-400">{t("Pesan Foto / Video AI")}</a>
    </section>
  );
}
